export const SET_CHECKMARK = 'SET_CHECKMARK';
export const SET_SIDEBAR = 'SET_SIDEBAR';
export const CLEAR_CHECKMARK = 'CLEAR_CHECKMARK';
export const TOGGLE_NAVIGATION_VISIBILITY = 'TOGGLE_NAVIGATION_VISIBILITY';
export const TOGGLE_SIDE_BAR_CLOSED = 'TOGGLE_SIDE_BAR_CLOSED';

export default SET_CHECKMARK;
